import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  {
    // Education Slide
    field: 'gadEducationSlide',
    type: 'info',
    educationalSlide:
      'Over the last 2 weeks, how often have you been bothered by the following problems?',
    label: '',
    answer: {}
  },

  {
    // 1
    label: 'I have been able to laugh and see the funny side of things:',
    field: 'epdsFunnySide',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '0', value: 'As much as I always could' },
        { key: '1', value: 'Not quite so much now' },
        { key: '2', value: 'Definitely not so much now' },
        { key: '3', value: 'Not at all' }
      ]
    }
  },

  {
    // 2
    label: 'I have looked forward with enjoyment to things:',
    field: 'epdsLookedEnjoyment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '0', value: 'As much as I ever did' },
        { key: '1', value: 'Rather less than I used to' },
        { key: '2', value: 'Definitely less than I used to' },
        { key: '3', value: 'Hardly at all' }
      ]
    }
  },

  {
    // 3
    label: 'I have blamed myself unnecessarily when things went wrong:',
    field: 'epdsBlamedSelf',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '3', value: 'Yes, most of the time' },
        { key: '2', value: 'Yes, some of the time' },
        { key: '1', value: 'Not very often' },
        { key: '0', value: 'No, never' }
      ]
    }
  },

  {
    // 4
    label: 'I have been anxious or worried for no good reason:',
    field: 'epdsAniousGood',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '0', value: 'No, not at all' },
        { key: '1', value: 'Hardly ever' },
        { key: '2', value: 'Yes, sometimes' },
        { key: '3', value: 'Yes, very often' }
      ]
    }
  },

  {
    // 5
    label: 'I have felt scared or panicky for no good reason:',
    field: 'epdsScaredGood',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '3', value: 'Yes, quite a lot' },
        { key: '2', value: 'Yes, sometimes' },
        { key: '1', value: 'No, not much' },
        { key: '0', value: 'No, not at all' }
      ]
    }
  },

  {
    // 6
    label: 'Things have been getting to me:',
    field: 'epdsThingsGetting',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: '3',
          value: 'Yes, most of the time I haven’t been able to cope at all'
        },
        {
          key: '2',
          value: 'Yes, sometimes I haven’t been coping as well as usual'
        },
        { key: '1', value: 'No, most of the time I have coped quite well' },
        { key: '0', value: 'No, I have been coping as well as ever' }
      ]
    }
  },

  {
    // 7
    label: 'I have been so unhappy that I have had difficulty sleeping:',
    field: 'epdsDifficultySleeping',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '3', value: 'Yes, most of the time' },
        { key: '2', value: 'Yes, sometimes' },
        { key: '1', value: 'No, not very often' },
        { key: '0', value: 'No, not at all' }
      ]
    }
  },

  {
    // 8
    label: 'I have felt sad or miserable:',
    field: 'epdsFeltSad',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '3', value: 'Yes, most of the time' },
        { key: '2', value: 'Yes, quite often' },
        { key: '1', value: 'Not very often' },
        { key: '0', value: 'No, not at all' }
      ]
    }
  },

  {
    // 9
    label: 'I have been so unhappy that I have been crying:',
    field: 'epdsBeenCrying',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '3', value: 'Yes, most of the time' },
        { key: '2', value: 'Yes, quite often' },
        { key: '1', value: 'Only occasionally' },
        { key: '0', value: 'No, never' }
      ]
    }
  },

  {
    // 10
    label: 'The thought of harming myself has occurred to me:*',
    field: 'epdsHarmingSelf',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '3', value: 'Yes, quite often' },
        { key: '2', value: 'Sometimes' },
        { key: '1', value: 'Hardly ever' },
        { key: '0', value: 'Never' }
      ]
    }
  },

  {
    // 11
    label: 'Your evaluated score',
    field: 'epdsEvaluated',
    type: 'evaluated',
    answer: answers => {
      let score = 0;
      Object.keys(answers).map(key => {
        const answer = answers[key];
        if (Object.keys(answer).length === 1) {
          score += parseInt(Object.keys(answer)[0], 10);
        }
      });
      return score;
    }
  },

  {
    //11
    label:
      'If you checked off any problems, how difficult have these problems made it for you to do your work, take care of things at home, or get along with other people?',
    field: 'gadHowDifficult',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'phqNotDifficult',
          value: 'Not difficult at all'
        },
        {
          key: 'phqSomewhatDifficult',
          value: 'Somewhat difficult'
        },
        {
          key: 'phqVeryDifficult',
          value: 'Very difficult'
        },
        {
          key: 'phqExtremelyDifficult',
          value: 'Extremely difficult'
        }
      ]
    }
  },

  {
    // Education Slide
    field: 'epdsEducationSlide',
    type: 'info',
    educationalSlide:
      'Thank you for completing this survey. Your doctor will score this survey and discuss the results with you.',
    label: '',
    answer: {}
  }
];

export default questionsModels;
